"use client";

import dynamic from "next/dynamic";
import { useEffect, useRef, useState } from "react";
import { prefersStaticSections } from "@/lib/motion/static-sections";
import { cn } from "@/lib/utils";

const ServiceIllustration = dynamic(
  () => import("@/components/home/services/ServiceIllustration"),
  { ssr: false },
);

export default function ServiceIllustrationLazy({
  slug,
  className,
}: {
  slug: string;
  className?: string;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (prefersStaticSections()) {
      setShouldLoad(true);
      return;
    }

    const node = containerRef.current;
    if (!node) {
      return;
    }

    if (!("IntersectionObserver" in window)) {
      setShouldLoad(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px 0px" },
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className={cn(className)}>
      {shouldLoad ? (
        <ServiceIllustration slug={slug} className="size-full" />
      ) : null}
    </div>
  );
}
